import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { Platform, WriteDirection } from 'sofa-reborn-react';
import styled from 'styled-components';

const borderColor = SkapaTheme.color.border.light;

export const RootDiv = styled.div`
	display: flex;
`;

export const StyledIconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 32px;
`;

export const ButtonDiv = styled.div<{
	platform: Platform;
	leftBorder?: boolean;
	rightBorder?: boolean;
	bottomBorder?: boolean;
	paddingLeft?: boolean;
	marginRight?: boolean;
	marginLeft?: boolean;
	alignSelfCenter?: boolean;
	paddingTop?: boolean;
	paddingBottom?: boolean;
}>`
	cursor: pointer;
	height: ${(props) => (props.platform === 'kiosk' ? '56px' : '32px')};
	width: ${(props) => (props.platform === 'kiosk' ? '56px' : '32px')};
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	${(props) => props.alignSelfCenter && 'align-self: center'};
	${(props) =>
		props.paddingLeft &&
		`
				padding-left: 12px;
			`}
	${(props) =>
		props.marginRight &&
		`
				margin-right: 12px;
			`}
			${(props) =>
		props.marginLeft &&
		`
				margin-left: 12px;
			`}
			${(props) =>
		props.paddingTop &&
		`
				padding-top: 12px;
			`}
			${(props) =>
		props.paddingBottom &&
		`
				padding-bottom: 12px;
			`}
			${(props) =>
		props.leftBorder &&
		`
				border-left: 1px solid ${borderColor};
			`}
			${(props) =>
		props.rightBorder &&
		`
				border-right: 1px solid ${borderColor};
			`}
			${(props) =>
		props.bottomBorder &&
		`
				border-bottom: 1px solid ${borderColor};
			`}
`;

export const InfoRotateWrapper = styled.div<{
	showColorOptions: boolean;
}>`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: ${(props) => (props.showColorOptions ? 'column' : 'row')};
`;

export const ColorOptionsWrapper = styled.div<{
	showInfoButton: boolean;
	showRotateButton: boolean;
	showRemoveButton: boolean;
	writeDirection: WriteDirection;
}>`
	${(props) =>
		((props.showInfoButton || props.showRotateButton) && props.writeDirection === 'ltr') ||
		(props.showRemoveButton && props.writeDirection === 'rtl')
			? 'border-left: 1px solid' + borderColor
			: null};
	${(props) =>
		(props.showRemoveButton && props.writeDirection === 'ltr') ||
		((props.showInfoButton || props.showRotateButton) && props.writeDirection === 'rtl')
			? 'border-right: 1px solid' + borderColor
			: null};
`;

export const BackDrop = styled.div`
	width: 100%;
	height: 230px;
	position: absolute;
	bottom: 0;
	background-color: #fff;
	opacity: 80%;
	z-index: 1;
`;
